import * as React from "react";
import {createRoot} from "react-dom/client";
import App from "../components/App";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

root?.render(<App />);

if ((module as any).hot) {
    (module as any).hot.accept("../components/App", () => {
        const NextApp = require("../components/App").default;
        root?.render(NextApp);
    });
}